(function () {
    'use strict';

    angular.module("imApp").factory("stockPlaceService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 738,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 739,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
